import { createUseStyles } from 'react-jss'

export default createUseStyles({
  image: {
    '&:hover': {
      cursor: 'pointer'
    }
  }
})
